import emailTemplatesReducer from '@features/emailTemplatesSlice';
import emailsReducer from '@features/emailsSlice';
import formsReducer from '@features/formsSlice';
import landingPageTemplatesReducer from '@features/landingPageTemplatesSlice';
import landingPagesReducer from '@features/landingPagesSlice';
import loginReducer from '@features/loginSlice';
import programsReducer from '@features/programsSlice';
import snippetsReducer from '@features/snippetsSlice';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

const rootReducer = combineReducers({
  login: loginReducer,
  programs: programsReducer,
  emailTemplates: emailTemplatesReducer,
  emails: emailsReducer,
  forms: formsReducer,
  landingPageTemplates: landingPageTemplatesReducer,
  landingPages: landingPagesReducer,
  snippets: snippetsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export const store = configureStore({
  reducer: rootReducer,
});
